<template>
  <v-container>
    <v-row>
      <v-col lg="10" md="12" xs="12">
        <app-personal
          :personal_information="personal_information"
          :image_src="image_src"
        />
        <app-contact
          :contact_information="contact_information"
        />
        <app-job
          :job_information="job_information"
        />
        <app-education
          :education_list="educations"
        />
        <app-language
          :lang_list="languages"
        />
        <app-skill
          :skill_list="skills"
        />
        <app-experience
          :experience_list="experiences"
        />
        <div class="text-left">
          <v-btn
            class="mx-2"
            small
            exact
            :to="{ name: 'supporter-list' }"
          >
            Back
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers'
  export default {
    name: 'SupporterView',
    components: {
      AppPersonal: () => import('../components/personal.view'),
      AppContact: () => import('../components/contact.view'),
      AppJob: () => import('../components/job.view'),
      AppSkill: () => import('../components/skill.view'),
      AppExperience: () => import('../components/experience.view'),
      AppLanguage: () => import('../components/language.view'),
      AppEducation: () => import('../components/education.view'),
    },
    data: () => ({
      supporter_id: null,
      skills: [],
      experiences: [],
      languages: [],
      educations: [],
      img_base_url: process.env.VUE_APP_IMG_BASE_URL,
      image_src: '',
      personal_information: {
        profile_image_url: null,
        firstname: null,
        display_name: null,
        gender: null,
        birthdate: null,
        weight: null,
        height: null,
        marriage_status: null,
        nationality: null,
        religion: null,
        personal_id: null,
        passport_id: null,
        driving_license: false,
        motorbike_driving_license: false,
        vaccine: false,
        work_permit: false,
        work_permit_expiration_date: null
      },
      contact_information: {
        email: null,
        phone_number: null,
        line_id: null,
        address_glat: null,
        address_glng: null,
        address_sub_district: null,
        address_district: null,
        address_province: null,
        address_country: null,
        address_postal_code: null,
        address_detail: null,
        emergency_contact_person: null,
        emergency_contact_phone: null,
      },
      job_information: {
        job_roles: [],
        job_live: null,
        job_type: null,
        expected_salary: null,
        reference_person: null,
        reference_contact: null,
        active: null,
        internal_code: null,
        remark: null,
        comment: null,
        bank_name: null,
        bank_account_name: null,
        bank_account_number: null
      },
    }),
    async mounted () {
      let id = this.$route.params.id
      await this.getSupporter(id)
    },
    methods: {
      async getSupporter (id) {
        this.supporter_id = id
        try {
          const supporter = await this.$http.get(`/back-office/supporters/${this.supporter_id}`, authHeader())
          this.personal_information.profile_image_url = supporter.data.profile_image_url
          this.personal_information.firstname = supporter.data.firstname
          this.personal_information.display_name = supporter.data.display_name
          this.personal_information.gender = supporter.data.gender
          this.personal_information.birthdate = supporter.data.birthdate
          this.personal_information.weight = supporter.data.weight
          this.personal_information.height = supporter.data.height
          this.personal_information.marriage_status = supporter.data.marriage_status
          this.personal_information.nationality = supporter.data.nationality
          this.personal_information.nationality_other = supporter.data.nationality_other
          this.personal_information.religion = supporter.data.religion
          this.personal_information.personal_id = supporter.data.personal_id
          this.personal_information.passport_id = supporter.data.passport_id
          this.personal_information.driving_license = supporter.data.driving_license
          this.personal_information.motorbike_driving_license = supporter.data.motorbike_driving_license
          this.personal_information.vaccine = supporter.data.vaccine
          this.personal_information.work_permit = supporter.data.work_permit
          this.personal_information.work_permit_expiration_date = supporter.data.work_permit_expiration_date
          this.contact_information.email = supporter.data.email
          this.contact_information.phone_number = supporter.data.phone_number
          this.contact_information.line_id = supporter.data.line_id
          this.contact_information.address_glat = Number(supporter.data.address_glat)
          this.contact_information.address_glng = Number(supporter.data.address_glng)
          this.contact_information.address_detail = supporter.data.address_detail
          this.contact_information.address_sub_district = supporter.data.address_sub_district
          this.contact_information.address_district = supporter.data.address_district
          this.contact_information.address_province = supporter.data.address_province
          this.contact_information.address_country = supporter.data.address_country
          this.contact_information.address_postal_code = supporter.data.address_postal_code
          this.contact_information.emergency_contact_person = supporter.data.emergency_contact_person
          this.contact_information.emergency_contact_phone = supporter.data.emergency_contact_phone
          this.job_information.job_roles = supporter.data.job_roles
          this.job_information.job_live = supporter.data.job_live
          this.job_information.job_type = supporter.data.job_type
          this.job_information.expected_salary = supporter.data.expected_salary
          this.job_information.job_location = supporter.data.job_location
          this.job_information.bank_name = supporter.data.bank_name
          this.job_information.bank_account_name = supporter.data.bank_account_name
          this.job_information.bank_account_number = supporter.data.bank_account_number
          this.job_information.reference_person = supporter.data.reference_person
          this.job_information.reference_contact = supporter.data.reference_contact
          this.job_information.active = supporter.data.active
          this.job_information.internal_code = supporter.data.internal_code
          this.job_information.remark = supporter.data.remark
          this.job_information.comment = supporter.data.comment
          this.educations = supporter.data.supporter_educations
          this.languages = supporter.data.supporter_languages
          this.skills = supporter.data.supporter_skills
          this.experiences = supporter.data.supporter_experiences
          this.image_src = `${this.img_base_url}/uploads/supporters/${this.personal_information.profile_image_url}`
        } catch (error) {
          console.log(error)
        }
      },
    }
  }
</script>
